<template>
	<div class="alert">
		<p>{{message}}
			<button @click="buttonAction" class="alert__button" v-if="button">{{button.message}}</button>
		</p>
	</div>
</template>

<script>
export default {
	components: {
	},
	props: {
		message: String,
		button: Object
	},
	data () {
		return {
		}
	},
	methods: {
		buttonAction () {
			this.$emit(this.button.action)
		}
	},
	computed: {
	}
}
</script>

<style lang="scss" scoped>
@import "@/styles/components/_alert.scss";
</style>
